// extracted by mini-css-extract-plugin
export default {"filtersContainer":"TabbedFilters_filtersContainer__rMlez","tabContainer":"TabbedFilters_tabContainer__cPKbS","tab":"TabbedFilters_tab__Ztg-N","active":"TabbedFilters_active__qtVa8"};